import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

import Moment from 'moment'

import Tooltip from '../../highcharts/components/tooltip/tooltip-wrapper'

const useStyles = makeStyles({
  tooltipWidth: {
    maxWidth: 'none'
  }
})

const Time = styled.span`
  opacity: 0.5;
  margin-left: ${({ theme }) => theme.spacing(2)}px;
`

const DateTime = ({ momentDate }) => (
  <span className='crm-time-wrapper'>
    {momentDate.format('MM-DD-YYYY')}
    <Time>{momentDate.format('h:mm A')} EST</Time>
  </span>
)

DateTime.propTypes = {
  momentDate: PropTypes.object.isRequired
}

const formatDateTime = dateTime => {
  return Moment(dateTime).tz('America/New_York')
}

const TimeFormat = ({ date, hideOldDate }) => {
  const momentDate = formatDateTime(date)
  const now = Moment.tz('America/New_York')
  const isBefore = momentDate.isBefore(now)

  // default server value is 01/01/0001, minus the 5 hour utc offset results in 12/31/0000
  const isDefaultServerValue = momentDate.year() === 0

  const classes = useStyles()

  if (!date || (hideOldDate && isBefore) || isDefaultServerValue) {
    return '-'
  }

  const localTimeZone = Moment.tz.guess(true)

  const enableTooltip = localTimeZone !== 'America/New_York'

  return (
    enableTooltip
      ? <Tooltip
        classes={{ tooltip: classes.tooltipWidth }}
        title={`${localTimeZone} time: ${Moment(date).tz(localTimeZone).format('MM-DD-YYYY h:mm A')}`}
      >
        <span>
          <DateTime momentDate={momentDate} />
        </span>
      </Tooltip>
      : <DateTime momentDate={momentDate} />
  )
}

const getFormattedDateTimeString = dateTime => {
  const momentDate = formatDateTime(dateTime)

  return `${momentDate.format('MM-DD-YYYY h:mm A')} EST`
}

TimeFormat.propTypes = {
  date: PropTypes.string,
  hideOldDate: PropTypes.bool
}

export default TimeFormat
export { getFormattedDateTimeString }
